import {
  ConsentPurpose,
  UserConsent,
  functional,
  performance,
  targeting
} from "cookiesConsent/domain/consent"
import { Tracker } from "cookiesConsent/domain/Tracker"
import { TrackerInventoryFactory } from "cookiesConsent/domain/TrackerInventory"

const purposesByCategory: Record<string, ConsentPurpose> = {
  performance,
  functional,
  targeting
}

const expire = (name: string): void => {
  document.cookie = `${name}=; Max-Age=0; Path=/`
  document.cookie = `${name}=; Max-Age=0; Path=/; Domain=.${window.location.hostname.replace(
    /^www\./,
    ``
  )}`
}

const deniedUnder = (consent: UserConsent, tracker: Tracker): boolean => {
  const purpose = purposesByCategory[tracker.category]

  if (!purpose) {
    return false
  } else {
    return !consent.permits(purpose)
  }
}

export const expireTrackersOutsideConsent = (consent: UserConsent): void => {
  new TrackerInventoryFactory()
    .fromSeed()
    .all()
    .filter(tracker => deniedUnder(consent, tracker))
    .forEach(tracker => tracker.cookies.forEach(expire))
}
